import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as messageStatus from '../message-status'

export const RESOURCE = {
  payload: {
    description: 'Message is being processed',
    enumId: core.dms.models.Enum.Id.from({
      partialId: messageStatus.RESOURCE.payload.partialId,
    }),
    id: 'pending',
    name: 'Pending',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
